export default {
  title: 'Prescribing physician information',
  titleDescription: 'Complete the following information to continue',
  nameLabel: 'Name and Lastname',
  specialtyLabel: 'Specialty',
  license: 'License',
  countryLabel: 'Country code',
  providerCode: 'Provider code',
  doctorTitle: "Prescribing physician data",
  doctorDescription:"Enter the following information",
  diagnosesTitle: "Diagnoses",
  productsTitle: "Products",
  prescriptionTitle: "Prescription",
  prescriptionDescription: "Files in PDF, PNG or JPEG format, maximum size 20Mb",
  illnessOnset: "Illness Onset",
  examTitle: "Exam",
  documentToUploadTitleOptional: "{title} (Optional)",
  buttons: {
    add: "Add"
  },
  noFiles: "No files attached",
  diagnoses: {
    panelTitle: 'Diagnoses',
    title: 'Diagnoses',
    emptyDiagnoses: 'Diagnoses have not been added yet',
    customDiagnosisItemListLabel: 'Diagnosis',
    searchLabel: 'Add diagnosis',
    emptyList: 'No results found',
    addDiagnosisLabel: '+ Add "{value}"',
    maximumNumberOfItemsReached: 'The limit has been exceeded',
    errors: {
      repeated: 'You have already added this diagnosis'
    },
    loading: "Loading..."
  },
  products: {
    emptyList: 'No results found',
    addLabel: '+ Add "{value}"',
    maximumNumberOfItemsReached: 'The limit has been exceeded',
    searchLabel: 'Add laboratory test',
    customDiagnosisItemListLabel: 'Laboratory Test',
  },
  fileUpload: {
    errors: {
      multipleFileUpload: "Only one file can be uploaded at a time",
      fileTypeIncorrect: "File type incorrect",
      fileSizeIncorrect: "File size exceeds 20mb",
      fileMaxAttachment: "File limit exceeded",
      fileUploadError: "There was an issue uploading the file. Please try again."
    },
    labels: {
      studiesReport: "Report of studies carried out",
      prescription: "Medical indication",
      procedureDescription: "Description sheet of the procedure performed",
      pathologyResult: "Pathology Report Result",
      anesthesiaFile: "Anesthesia sheet",
      ambulatoryCareForm: "Outpatient Care Form"
    }
  },
  validations: {
    prescription: "Enter the doctor's details.",
    diagnoses: "Add at least one diagnosis.",
    treatments: "Add at least one product.",
    exams: "Add at least one exam.",
    receiptFile: "Add required files."
  },
  riskManager: "Authorization of Labor Risk Administrator (ARL)"
}
